/**
 * Islam hub content API (articles, reminders, educational).
 */
import api from './api/axiosConfig';

const islamService = {
  /**
   * @param {Object} params - page_size, category, language ('en' | 'ur')
   */
  getContents: async (params = {}) => {
    const response = await api.get('/islam/', { params });
    return response.data;
  },

  getContent: async (slug, language) => {
    const params = language ? { language } : {};
    const response = await api.get(`/islam/${slug}/`, { params });
    return response.data;
  },
};

export default islamService;
